import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";
import { recaptchaObject } from "../recaptcha";
require('parsley');
import 'MagnificPopup';
import * as moment from 'moment';
require('datatables.net');
require('datatablesResponsive');


export class enrichVoucherRedemption {
	private goldRdmForm: any = $('#enrich-voucher-redemption');
	private goldRdmForm1: any = $('#enrich-input-voucher-redemption');
	private goldRdmForm2: any = $('#enrich-voucher-checking-screen');
	private memberBase: any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr: any = $.makeArray(_self.goldRdmForm.find('input[type="text"], input[type="password"]'));
		let inputElArr1: any = $.makeArray(_self.goldRdmForm1.find('input[type="text"]'));
		let inputElArr2: any = $.makeArray(_self.goldRdmForm2.find('input[type="text"], textarea'));
		_self.memberBase.initFormTextInputs(inputElArr);
		_self.memberBase.initFormTextInputs(inputElArr1);
		_self.memberBase.initFormTextInputs(inputElArr2);		
	}


	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.goldRdmForm, function (validation: any) {
			// all your custom validation here

			$('#enrich-voucher--redemption-receipt-amount').attr('step', '0.01');
			$('#enrich-voucher--redemption-receipt-amount').attr('placeholder', '00.00');
		});
		_self.memberBase.validateForm(_self.goldRdmForm1, function (validation: any) {
			// all your custom validation here
		});
		_self.memberBase.validateForm(_self.goldRdmForm2, function (validation: any) {
			// all your custom validation here
		});
	}
	initRecaptcha(): any {

		let _self = this;
		let _body = $('body');
		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo: recaptchaInfo = {
			id: 'enrich-voucher-redemption-recaptcha',
			cb: 'recaptchaCorporateSuccess',
			cbObj: function () {
				(document.getElementById('enrich-voucher-redemption-recaptcha') as HTMLInputElement).value = 'true';
			},
			displayId: 'enrich-redemption--grecaptcha',
			formEl: _self.goldRdmForm
		};
		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}
	enableMarkasRead(): any {
		$('#enrich--form--checkbox').change(function () {
			if (this.checked) {
				$("#enrich-input-voucher-checkingstatus").removeClass("disabled");
			} else {
				$("#enrich-input-voucher-checkingstatus").addClass("disabled");
			}
		});
	}
	backtovoucherinput(): any {
		$("#enrich-input-voucher-clear").click(function () {
			let _self = this;
			let bcommon = _self.bookingformcommon;
			let cookieList = document.cookie.split(';');
			let isUserLoggedIn = false;
			if (cookieList) {
				for (let i = 0; i < cookieList.length; i++) {
					const cookieItem = cookieList[i].split('=');
					if (cookieItem[0].trim() === 'p_loggedinuser') {
						isUserLoggedIn = true;
						break;
					}
				}
			}
			if (isUserLoggedIn) {
				$("#enrich-voucher-checking-screen").addClass("hideclass");
				$("#enrich-input-voucher-redemption").removeClass("hideclass");
				$(" #enrich-used-voucher-partner .members-content-containers").addClass("hide");
				$(" #enrich-used-voucher-partner").removeClass("hide");
				$("#enrich-redemption--voucherinput").val("");
			} else {
				$("#enrich-voucher-redemption").removeClass("hideclass");
				$("#enrich-voucher-checking-screen").addClass("hideclass");
				$(" #enrich-used-voucher-partner").addClass("hide");
				window.location.reload();
			}
		});
	}

	validateLoggedInUser(): any {
		$("#enrich-voucherportal-form-section").addClass("hide");
		$(" #enrich-used-voucher-partner").addClass("hide");
		let cookieList = document.cookie.split(';');
		let isUserLoggedIn = false;
		if (cookieList) {
			for (let i = 0; i < cookieList.length; i++) {
				const cookieItem = cookieList[i].split('=');
				if (cookieItem[0].trim() === 'p_loggedinuser') {
					isUserLoggedIn = true;
					break;
				}
			}
			if (isUserLoggedIn) {
				$("#enrich-voucherportal-form-section").removeClass("hide");
				$("#enrich-voucher-redemption").addClass("hideclass");
				$("#enrich-input-voucher-redemption").removeClass("hideclass");
				$(" #enrich-used-voucher-partner").removeClass("hide");
			} else {
				$("#enrich-voucherportal-form-section").removeClass("hide");
				$("#enrich-voucher-redemption").removeClass("hideclass");
				$(" #enrich-used-voucher-partner").addClass("hide");
				// $("form input").val("");
				// location.reload(true);
			}
		}
	}

	preventDefaultFormSubmissionBehaviour(): any {
		$("#enrich-input-voucher-redemption").on("submit", function (event: any) {
			event.preventDefault();
			return false;
		});
	}
	getUsedVoucherList() {
		$('#enrich-used-voucher-partner .link-view-used').click(function () {
			let formData: Array<any> = [];
			formData.push({
				"name": "username",
				"value": $('#enrich-voucher-redemption #enrich-redemption--username').val()
			});
			if (location.host == "localhost:5000") {
				$.ajax({
					type: 'GET',
					url: 'http://localhost:5000/dummy-data/usedVoucherList.JSON',
					data: formData,
					contentType: 'application/json',
					success: function (data: any) {
						createUsedVoucherTable(data.usedVoucherList);
						$("#DataTables_Table_UsedVouchers_length").hide();
						$("#enrich-used-voucher-partner .members-content-containers").removeClass('hide');
						// createPagination(currentPageNumber, data.numberOfPages);
					},
					error: function (error: any) {
						$("#enrich-input-voucher-redemption .error-validation").html("Something went wrong, Please try again after sometime.");
						$("#enrich-input-voucher-redemption .error-validation").css("display", "block");
						$("#enrich-input-voucher-redemption .error-validation").addClass('mandatory-text');
						$('body').animate({
							'scrollTop': 100
						}, 500, function () { });
					}
				});

			} else {
				$.ajax({
					type: 'GET',
					url: '/bin/services/new/partnerportal/viewusedvoucherlist',
					data: formData,
					contentType: 'application/json',
					success: function (data: any) {
						createUsedVoucherTable(data.usedVoucherList);
						$("#DataTables_Table_UsedVouchers_length").hide();
						$("#enrich-used-voucher-partner .members-content-containers").removeClass('hide');
						// createPagination(currentPageNumber, data.numberOfPages);
					},
					error: function (error: any) {
						$("#enrich-input-voucher-redemption .error-validation").html("Something went wrong, Please try again after sometime.");
						$("#enrich-input-voucher-redemption .error-validation").css("display", "block");
						$("#enrich-input-voucher-redemption .error-validation").addClass('mandatory-text');
						$('body').animate({
							'scrollTop': 100
						}, 500, function () { });
					}
				});

			}
		});
		function createUsedVoucherTable(jsonDataArray: any) {

			let usedVoucherTable = $('#DataTables_Table_UsedVouchers');
			// jsonDataArray = jsonDataArray.map(data => { data.flightDate = moment(data.flightDate, 'DD-MM-YYYY').format('YYYY-MM-DD'); return data })
			usedVoucherTable.dataTable().fnClearTable();
			usedVoucherTable.dataTable().fnDestroy();
			let dataSet = jsonDataArray;
			let tableOptions = {
				data: dataSet,
				"columns": [
					{ "data": "voucherCode" },
					{ "data": "enrichID" },
					{ "data": "enrichName" },
					{ "data": "voucherUsedDate", "render": formatDates },
					{ "data": "receiptNumber" },
					{ "data": "receiptAmount" },
					{ "data": "remarksFromPartner" }
				]

			}

			let benefitsDataTable: any = usedVoucherTable.dataTable(tableOptions);

		}
		function formatDates(data: any, type: any, row: any) {
			if (type === "sort" || type === "type") {
				return data;
			}
			return moment(data, 'YYYY-MM-DD').format('DD-MM-YYYY');

		}


	}
	exportToExcel() {
		$('#enrich-used-voucher-partner .export_excel_used_voucher').click(function () {
			let formData: Array<any> = [];
			formData.push({
				"name": "username",
				"value": $('#enrich-voucher-redemption #enrich-redemption--username').val()
			});
			let usedVoucherUrl: string = '';
			if (location.host == "localhost:5000") {
				usedVoucherUrl = "http://localhost:5000/dummy-data/usedVoucherList.JSON";
			}
			else {
				usedVoucherUrl = '/bin/services/new/partnerportal/viewusedvoucherlist';
			}
			$.ajax({
				type: 'GET',
				url: usedVoucherUrl,
				data: formData,
				contentType: 'application/json',
				success: function (msg: any) {
					let responsedata: any = null;
					if (typeof msg === 'string') {
						responsedata = JSON.parse(msg);
					}
					else {
						responsedata = msg;
					}
					let createXLSLFormatObj: any = [];
					let xlsHeader: any = ["Voucher Code", "Enrich ID", "Voucher Owner", "Status Used", "Bill/Receipt No.", "Amount", "Remark to Enrich"];
					let xlsRows: any = responsedata.usedVoucherList;
					createXLSLFormatObj.push(xlsHeader);
					$.each(xlsRows, function (index: any, value: any) {
						let innerRowData: any = [];
						$.each(value, function (ind: any, val: any) {
							innerRowData.push(val);
						});
						createXLSLFormatObj.push(innerRowData);
					});
					let filename: string = "Used_Voucher_list.xls";
					let ws_name: string = "Used Voucher List";
					let wb: any = XLSX.utils.book_new(),
						ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
					XLSX.utils.book_append_sheet(wb, ws, ws_name);
					XLSX.writeFile(wb, filename);
				},
				error: function (error: any) {
					$("#enrich-input-voucher-redemption .error-validation").html("Something went wrong, Please try again after sometime.");
					$("#enrich-input-voucher-redemption .error-validation").css("display", "block");
					$("#enrich-input-voucher-redemption .error-validation").addClass('mandatory-text');
					$('body').animate({
						'scrollTop': 100
					}, 500, function () { });
				}
			});
		});
	}

}
let scope: Element = document.querySelector('#enrich-voucher-redemption');

if (scope) {
	try {
		let membergrv = new enrichVoucherRedemption();
		membergrv.validateLoggedInUser();
		membergrv.initTextInputs();
		membergrv.initRecaptcha();
		membergrv.validateForm();
		membergrv.enableMarkasRead();
		membergrv.backtovoucherinput();
		membergrv.preventDefaultFormSubmissionBehaviour();
		membergrv.getUsedVoucherList();
		membergrv.exportToExcel();
	} catch (e) { console.error(e); }
}
